// Stub for NestJS 10 `@nestjs/core/repl` in the browser bundle.
// ApplicationContext DI never needs the Node REPL helpers.
module.exports = {};
